/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from "react";

/** Common Components */
import FormCreator from "../../../../../../../components/finalForms/FormCreator";
import Buttons from "../../../../../../../components/ui/button/Buttons";

/** Configuration files */
import { updateCostConfig } from "./UpdateContractRenewalScope";
import { useUpdateRenewalScopeMutation } from "../../../../../../../app/services/contractAPI";
import ToastService from "../../../../../../../services/toastService/ToastService";
import { ContractContext } from "../../../../../../../utils/context/ContractContext";

const UpdateRenewal = ({ row, onClose, gridRefresh }) => {

    const { contractId } = useContext(ContractContext);
    const UpdateRenewalRef = useRef();
    const [updateCostForm, setUpdateCostForm] = useState(updateCostConfig)

    const [UpdateContractRenewalScope, {
        isSuccess: isUpdateContractRenewalScopeFetching,
        data: UpdateContractRenewalScopeData
    }] = useUpdateRenewalScopeMutation();

    useEffect(() => {
        if (row) {
            const updatedForm = { ...updateCostForm };
            updatedForm.initialState = {
                updateCost: row?.nCost
            };
            setUpdateCostForm(updatedForm);
        }
    }, [row]);

    useEffect(() => {
        if (isUpdateContractRenewalScopeFetching && UpdateContractRenewalScopeData) {
            if (UpdateContractRenewalScopeData) {
                ToastService.success(UpdateContractRenewalScopeData?.errorMessage);
                onClose();
                gridRefresh();
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isUpdateContractRenewalScopeFetching, UpdateContractRenewalScopeData]);

    const handleSave = () => {
        const formData = UpdateRenewalRef.current.getFormData();

        if (!formData) {
            ToastService.error("Please fill all required fields");
            return;
        }

        if (!formData) return;
        const req = {
            plScopeKey: row?.lScopeKey,
            plContractKey: contractId,
            pnCost: formData?.updateCost
        }
        UpdateContractRenewalScope(req)
    }

    return (
        <>
            <div className="row">
                <FormCreator ref={UpdateRenewalRef} config={updateCostForm} />
                <div className="d-flex justify-content-end gap-3 export-icon">
                    <Buttons
                        buttonText="Ok"
                        onClick={handleSave}
                        buttonTypeClassName="btn blue-btn"
                        titleText="Ok"
                    // isLoading={isDeleting}
                    />
                    <Buttons
                        buttonText="Cancel"
                        onClick={onClose}
                        buttonTypeClassName="btn blue-btn"
                        titleText="Cancel"
                    // isLoading={isDeleting}
                    />
                </div>
            </div>
        </>
    );
};
export default UpdateRenewal;
